import _ from 'lodash'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

// 注文詳細画面モード
const INPUT_TYPE = Object.freeze(
  {
    TEXT: 1,              // テキストボックス
    MULTI_LINE_TEXT: 2,   // 複数行テキストボックス
    MULTI_TEXT: 3,        // 複数テキストボックス
    HTML: 4,              // htmlテキストボックス
    NUMBER: 5,            // 数値
    DATE: 6,              // 日付
    DATETTIME: 7,         // 日時
    SELECT: 8,            // 単一選択
    MULTI_SELECT: 9,      // 複数選択
    OBJECT_ARRAY: 10,     // オブジェクト配列
    CHECK_BOX: 11,        // チェックボックス
    MULTI_NUMBER: 12,     // 複数テキストボックス(数値)
    DATE_MILLI_SECONDS: 13,           // 日付（ミリ秒）
    DATETIME_MILLI_SECONDS: 14        // 日時（ミリ秒）
  }
)
export default {
  getCustomizeColumn (displayItem, inputType, attrId, storePath) {
    const valuePath = 'attrValue'
    const editableId = 'attrId'

    let property = {}
    let index = -1
    property.path = valuePath
    property.editableId = editableId

    switch (inputType) {
      case INPUT_TYPE.HTML: // htmlテキストボックス（プレビュー付き）
      case INPUT_TYPE.SELECT: // 単一選択
      case INPUT_TYPE.MULTI_SELECT: // 複数選択
      case INPUT_TYPE.OBJECT_ARRAY: // オブジェクト配列 1階層下のみ対応
        // 未実装のためテキストボックスと同じにする
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT
        break
      case INPUT_TYPE.TEXT: // テキストボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT
        break
      case INPUT_TYPE.MULTI_LINE_TEXT: // 複数行テキストボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT_TEXT_AREA
        property.rows = 5
        property.class = 'multiLineTextBox'
        property.lineBreak = true
        break
      case INPUT_TYPE.MULTI_TEXT: // 複数テキストボックス（テキスト。内部データ：「"」括り。「,」区切り。）
      case INPUT_TYPE.MULTI_NUMBER: // 複数テキストボックス（テキスト。内部データ：「"」括り。「,」区切り。）
        // BASECELLのプロパティがメソッドの場合、実行した値になるように回収しておく
        property.elementType = ELEMENT_TYPE.CELL
        property.class = 'valueArray'
        property.editableId = editableId
        property.properties = (noUse, displayValue, editable) => {
          const property = []
          // カンマ区切りで配列分のCELLをを作成
          let values
          values = displayValue ? JSON.parse(displayValue) : null
          if (values == null || values.length === 0) {
            values = ['']
            displayValue = JSON.stringify(values)
          }
          values.forEach((value, arrayIndex) => {
            // テキストボックス + 削除ボタンの形式でCELLのプロパティを作成
            let propertiesData = [{
              type: inputType === INPUT_TYPE.MULTI_TEXT ? 'String' : 'Number',
              elementType: inputType === INPUT_TYPE.MULTI_TEXT ? ELEMENT_TYPE.INPUT : ELEMENT_TYPE.INPUT_NUMBER,
              path: `value.${arrayIndex}`,
              change: (event) => {
                const values = JSON.parse(displayValue)
                values[arrayIndex] = event
                _.set(displayItem, 'value', values)
                _.set(displayItem, valuePath, JSON.stringify(values))
              },
              editableId: editableId
            }]
            if (editable && values.length > 1) {
              propertiesData.push({
                type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'delBtn',
                icon: 'fas fa-times-circle', path: 'value',
                editableId: editableId,
                click: (event) => {
                  const values = JSON.parse(displayValue)
                  values.splice(arrayIndex, 1)
                  _.set(displayItem, 'value', values)
                  _.set(displayItem, valuePath, JSON.stringify(values))
                }
              })
            }
            if (editable && (values.length === arrayIndex + 1)) {
              propertiesData.push({
                type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
                icon: 'fas fa-plus-circle', path: 'value',
                editableId: editableId,
                size: 'small',
                click: (event) => {
                  const values = JSON.parse(displayValue)
                  values.push('')
                  _.set(displayItem, 'value', values)
                  _.set(displayItem, valuePath, JSON.stringify(values))
                }
              })
            }
            property.push({
              // カスタムタイプのセルを指定
              type: 'String', elementType: ELEMENT_TYPE.CELL,
              properties: propertiesData,
              index: index,
              horizontal: true
            })
          })

          return property
        }
        break
      case INPUT_TYPE.NUMBER: // 数値
        property.type = 'Number'
        property.elementType = ELEMENT_TYPE.INPUT_NUMBER
        break
      case INPUT_TYPE.DATE: // 日付
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE
        property.dateFormat = 'YYYY/MM/DD'
        break
      case INPUT_TYPE.DATE_MILLI_SECONDS:            // 日付（ミリ秒）
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE_MILLI_SECONDS
        property.dateFormat = 'YYYY/MM/DD'
        break
      case INPUT_TYPE.DATETTIME: // 日時
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE_TIME
        property.dateFormat = 'YYYY/MM/DD HH:mm:ss'
        break
      case INPUT_TYPE.DATETIME_MILLI_SECONDS:        // 日時（ミリ秒）
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATETIME_MILLI_SECONDS
        property.dateFormat = 'YYYY/MM/DD HH:mm:ss'
        break
      case INPUT_TYPE.CHECK_BOX: // チェックボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.CHECK_BOX
        property.path = 'value'
        _.set(displayItem, 'value', Boolean(Number(displayItem[valuePath] || 0)))
        property.change = (val) => {
          const setVal = Number(val)
          _.set(displayItem, valuePath, setVal)
        }
        break
    }

    return property
  }
}
